export const fileApiURl = {
  upload: "/files/uploads",
};
